export default __webpack_public_path__ + "static/media/settings-icon.d30cc4f9.svg";